export default __webpack_public_path__ + "static/media/company.f5b235b1.png";